import { Card, Skeleton } from '@heroui/react';
import { BlobsBackground } from '@milestone-portal/ui/BlobsBackground/BlobsBackground';
import { DesktopContainer } from '@milestone-portal/ui/DesktopContainer/DesktopContainer';
import { Footer } from '@milestone-portal/ui/Footer/Footer';
import { HeaderBar } from '@milestone-portal/ui/HeaderBar/HeaderBar';
import { useTranslation } from 'react-i18next';

export function PublicProfileSkeleton() {
  const { t } = useTranslation();

  return (
    <DesktopContainer>
      <BlobsBackground />
      <HeaderBar />

      <div className="mx-auto w-full p-4">
        <Card
          className="bg-default-100/20 flex gap-y-8 rounded-2xl"
          shadow="sm"
        >
          {/* 個人資料區塊 */}
          <Card className="relative flex flex-col items-center gap-4 p-4 text-center">
            <Skeleton className="bg-default-300/50 mx-auto size-32 rounded-full" />
            <Skeleton className="bg-default-300/50 mx-auto h-8 w-40 rounded-lg" />
            <Skeleton className="bg-default-300/50 mx-auto h-10 w-40 rounded-lg" />
            <Skeleton className="bg-default-300/50 mx-auto h-20 w-full max-w-2xl rounded-lg" />
          </Card>

          {/* 身份區塊 */}
          <div>
            <h2 className="mb-8 text-center text-2xl font-semibold">
              {t('identity')}
            </h2>
            <div className="mx-auto flex flex-wrap justify-center gap-6 px-4 md:px-8 lg:px-12">
              {Array.from(Array(3).keys()).map((i) => (
                <div
                  className="relative w-full md:w-[calc(50%-0.75rem)] xl:w-[calc(33.33%-1rem)]"
                  key={i}
                >
                  <Card
                    className="bg-default-100/40 flex size-full flex-col p-4"
                    radius="md"
                    shadow="none"
                  >
                    <div className="relative flex flex-1 flex-col gap-y-2">
                      <Skeleton className="bg-default-300/50 mx-auto size-[114px] rounded-full" />
                      <div className="flex flex-1 flex-col gap-y-2 text-center">
                        <Skeleton className="bg-default-300/50 mx-auto mb-1 h-6 w-3/4 rounded-lg" />
                        <Skeleton className="bg-default-300/50 mx-auto h-6 w-1/3 rounded-lg" />
                        <Skeleton className="bg-default-300/50 mx-auto h-6 w-1/2 rounded-lg" />
                      </div>
                    </div>
                  </Card>
                </div>
              ))}
            </div>
          </div>

          {/* 時間線區塊 - 大幅簡化 */}
          <div>
            <h2 className="mb-4 text-center text-2xl font-semibold">
              {t('careerTimeline')}
            </h2>
            <Skeleton className="bg-default-300/50 m-4 mx-auto h-[50vh] w-[95%] rounded-lg" />
          </div>
        </Card>
      </div>

      <Footer />
    </DesktopContainer>
  );
}
